/**
 * New Login 配置常量
 * 统一管理所有 Magic Numbers 和配置字符串
 * 避免在多个组件中重复硬编码
 */

// ==================== 表单配置 ====================

// 根据环境切换 Contact Us 用的展会 ID / 代码（PROD 用 9991/CPS22DB，UAT 用 9981/CPS22DBU）
const IS_UAT_ENV = process.env.VUE_APP_EMP_ENV_NAME === 'UAT';
const CONTACT_SHOW_ID = IS_UAT_ENV ? 9981 : 9991;
const CONTACT_SHOW_CODE = IS_UAT_ENV ? 'CPS22DBU' : 'CPS22DB';

/**
 * Contact Us 表单配置
 */
export const CONTACT_US_CONFIG = {
  BUYER: {
    fid: 1045,
    showid: CONTACT_SHOW_ID,
    showcode: CONTACT_SHOW_CODE,
    submitPageURL: 'VueContactUs'
  },
  SUPPLIER: {
    fid: 1044,
    showid: CONTACT_SHOW_ID,
    showcode: CONTACT_SHOW_CODE,
    submitPageURL: 'VueContactUs'
  }
};

/**
 * Become Supplier 表单配置
 */
export const BECOME_SUPPLIER_CONFIG = {
  fid: 1044,
  showid: CONTACT_SHOW_ID,
  showcode: CONTACT_SHOW_CODE,
  submitPageURL: 'VueBecomeSupplier'
};

// ==================== 默认值配置 ====================

/**
 * 默认语言ID
 */
export const DEFAULT_LANG_ID = 1252;

/**
 * 默认展会ID（CHINAPLAS 2022 DB）
 */
export const DEFAULT_SHOW_ID = CONTACT_SHOW_ID;

/**
 * 默认展会代码（CHINAPLAS 2022 DB）
 */
export const DEFAULT_SHOW_CODE = CONTACT_SHOW_CODE;

/**
 * 默认提交页面URL
 */
export const DEFAULT_SUBMIT_PAGE_URL = 'VueForm';

// ==================== 验证码配置 ====================

/**
 * 验证码类型
 */
export const CAPTCHA_TYPE = {
  GEETEST: 'Geetest',
  ALIYUN: 'Aliyun'
};

/**
 * 验证码相关默认值
 */
export const CAPTCHA_CONFIG = {
  ValType: 'Geetest',
  isCloud: 'true',
  IsAliyunValid: 'true',
  IsNewValidCode: 'true',
  isNotNeedValidate: 'false',
  typename: 'CPS_Login',
  RefererLink: 'https://www.chinaplasonline.com/eMarketplace'
};

// ==================== 状态码配置 ====================

/**
 * 提交结果状态码
 */
export const SUBMIT_STATUS_CODE = {
  SUCCESS: 200,
  CAPTCHA_FAILED: 1001,
  VALIDATION_ERROR: 400
};

// ==================== 工具函数 ====================

/**
 * 获取当前语言ID
 * @returns {number} 语言ID
 */
export function getCurrentLangId() {
  return parseInt(localStorage.getItem('currentLangId')) || DEFAULT_LANG_ID;
}

/**
 * 获取 Contact Us 配置（根据用户类型）
 * @param {string} userType - 用户类型 ('buyer' | 'supplier')
 * @returns {Object} Contact Us 配置
 */
export function getContactUsConfig(userType = 'supplier') {
  return userType === 'buyer' ? CONTACT_US_CONFIG.BUYER : CONTACT_US_CONFIG.SUPPLIER;
}

/**
 * 获取 Become Supplier 配置
 * @returns {Object} Become Supplier 配置
 */
export function getBecomeSupplierConfig() {
  return BECOME_SUPPLIER_CONFIG;
}

